module.exports = __webpack_public_path__ + "media/images/home-banner-a791d6a63b159b42699b3afdb07c23c7.png";